import { render, staticRenderFns } from "./StylesCopy.vue?vue&type=template&id=3a7dfcf2&"
import script from "./StylesCopy.vue?vue&type=script&lang=js&"
export * from "./StylesCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports